import React, { MutableRefObject, useEffect, useRef } from 'react'
import Input from 'components/base/Input'
import { XIcon } from 'components/base/XIcon/XIcon'
import 'components/base/InputClearable/InputClearable.scss'
import classNames from 'classnames'

type props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEnterKeyDown?: () => void;
  onBlur?: () => void;
  onClearInput?: () => void;
  value: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const InputLiveUrl = ({
  onClearInput = () => {},
  className,
  value,
  disabled,
  ...rest
}: props) => {
  const input: MutableRefObject<HTMLDivElement | undefined> = useRef()
  useEffect(() => {
    if (input.current) {
      window.requestAnimationFrame(() => {
        (input.current?.children[0] as HTMLInputElement)?.select()
      })
    }
  }, [])
  return (
    <div className={classNames('input-clearable__input', className)}>
      <Input value={value} {...rest} disabled={disabled} ref={input} autoFocus />
      {(!!value && !disabled) && (
        <div className="input-clearable__x-icon--input" onClick={onClearInput}>
          <XIcon />
        </div>
      )}
    </div>
  )
}

export default InputLiveUrl
